export const PAYMENT_FROM = {
  URL_LOCAL_STORAGE_KEY: 'fgm',
  URL_LOCAL_STORAGE_TTL: 600,
  REDIRECT_URL_LOCAL_STORAGE_KEY: 'deposit',
  REDIRECT_URL_LOCAL_STORAGE_TTL: 600,
};